module.exports = __webpack_public_path__ + "assets/img/Type E (14).e3cdfc0e.jpg";